import * as helpers from "../helpers";
import * as interfaces from "../../interfaces";
import DslElementType from "../../enums/DslElementType";
import { LocationProvider } from "../../../../monaco-helpers";

import { DoStatement } from "./DoStatement";
import { RawElement } from "../common";

export class GotoStatement extends DoStatement implements interfaces.IGotoStatement {
  elementType: DslElementType.GotoStatement = DslElementType.GotoStatement;
  targetTransition: RawElement<string>;

  constructor(obj: interfaces.IGotoStatement, locationProvider?: LocationProvider) {
    super(obj, locationProvider);
    this.targetTransition = helpers.ensureIsInstance(obj.targetTransition, RawElement<string>);
  }
  toJson(): interfaces.IGotoStatement {
    return {
      isDoSectionStatement: true,
      elementType: this.elementType,
      location: this.location,
      targetTransition: this.targetTransition.toJson(),
    };
  }
  toDsl(indent: number): string {
    return [helpers.indentString(indent), "goto ", this.targetTransition.value, ";"].join("");
  }
}
